import * as React from 'react';
import RenderHTML from 'automaailm-ui/lib/Components/RenderHTML/index';

export interface IBreadCrumbItem {
    label: string;
    url?: string;
}

interface IConfig {
    crumbs: IBreadCrumbItem[];
}

interface IProps {
    dom: string;
    config: IConfig;
}

const ProductDetailBreadcrumbs = (props: IProps) => {
    const { config, dom } = props;
    const breadcrumbsResponse = config.crumbs || [];

    return (
        <React.Fragment>
            {(dom && !breadcrumbsResponse) ||
                (breadcrumbsResponse.length < 1 && <RenderHTML html={dom} nowrapper={true} />)}
            {breadcrumbsResponse && (
                <ul className="path">
                    {breadcrumbsResponse.map((breadcrumbsResponseItem, key) => (
                        <React.Fragment key={key}>
                            <li className="item">
                                {breadcrumbsResponseItem.url && (
                                    <a href={breadcrumbsResponseItem.url}>{breadcrumbsResponseItem.label}</a>
                                )}
                                {!breadcrumbsResponseItem.url && (
                                    <strong>
                                        <span>{breadcrumbsResponseItem.label}</span>
                                    </strong>
                                )}
                            </li>
                        </React.Fragment>
                    ))}
                </ul>
            )}
        </React.Fragment>
    );
};

export default ProductDetailBreadcrumbs;
